import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  loading: false,
  // organisations: typeof window !== 'undefined' ? (localStorage.getItem('organizationsList') ? JSON.parse(localStorage.getItem('organizationsList')) : []) : [],
  organisations: [],
  clinics: [],
  error: "",
  neworganisationSuccess: "",
  neworganisationError: "",
  organisationTypes: [],
  todos: [],
  countries: [],
  orgCount: 0,
  // selectedOrg: typeof window !== 'undefined' && JSON.parse(localStorage.getItem('organization')) || {organizationId: null, organizationName: ""},
  selectedOrg: { organizationId: null, organizationName: "" },
  selectedClinic: { clinicId: null, clinicName: "", organizationId: null },
  patientSummaryTemplateCategories: [],
  organisationTabsValue: 0,
}

const organisationSlice = createSlice({
  name: "organisations",
  initialState,
  reducers: {
    fetchOrganisationsRequest: state => {
      state.loading = true
    },
    fetchOrganisationsSuccess: (state, action) => {
      state.loading = false
      state.organisations = action.payload || []
      // localStorage.setItem('organizationsList', JSON.stringify(action.payload || []))
      state.error = ""
    },
    fetchOrganisationsFailure: (state, action) => {
      state.loading = false
      state.organisations = []
      localStorage.setItem("organizationsList", [])
      state.error = action.payload
    },
    addOrganisationSuccess: (state, action) => {
      state.loading = false
      state.neworganisationSuccess = action.payload
    },
    addOrganisationFailure: (state, action) => {
      state.loading = false
      state.neworganisationError = action.payload
    },
    organisationTypes: (state, action) => {
      state.organisationTypes = action.payload
    },
    updateTodos: (state, action) => {
      // console.log('Updated todos:', action.payload);
      state.todos = action.payload
    },
    updateCountries: (state, action) => {
      state.countries = action.payload || []
    },
    updateOrgCount: (state, action) => {
      state.orgCount = action.payload
    },
    updateSelectedOrg: (state, action) => {
      state.selectedOrg = action.payload
    },
    updateSelectedClinic: (state, action) => {
      state.selectedClinic = action.payload
    },
    updatePatientSummaryTemplateCategories: (state, action) => {
      state.patientSummaryTemplateCategories = action.payload
    },
    updateOrganizationTabsValue: (state, action) => {
      state.organisationTabsValue = action.payload
    },
  },
})

export const {
  fetchOrganisationsRequest,
  fetchOrganisationsSuccess,
  fetchOrganisationsFailure,
  addOrganisationSuccess,
  addOrganisationFailure,
  organisationTypes,
  updateTodos,
  updateCountries,
  updateOrgCount,
  updateSelectedOrg,
  updateSelectedClinic,
  updatePatientSummaryTemplateCategories,
  updateOrganizationTabsValue,
} = organisationSlice.actions

export default organisationSlice.reducer
